export function percentByRange(min: number, max: number, value: number): number {
  const span = max - min;
  if (span === 0) return value >= max ? 100 : 0;

  const p = ((value - min) / span) * 100;
  return Math.max(0, Math.min(100, p));
}
